// src/shared/components/NotesMobileView/InfoConsent.jsx

export const infoConstant = (step) => {
   switch (step) {
      // Homescreen Info
      case 1:
         return {
            title: {
               step: null,
               mainTitle: "Create your first note in 3 steps",
            },
            subTitle: {
               icon: false,
               mainSubtitle: [
                  "Record a demo encounter",
                  "Format your note with a template",
                  "Customize with note tools",
               ],
            },
         };
      // Recording Info
      case 2:
         return {
            title: {
               step: 1,
               mainTitle: "Record a demo encounter",
            },
            subTitle: {
               icon: true,
               mainSubtitle: [
                  "Create a demo patient case",
                  "Mention a name and demographics",
                  "Speak naturally - no need to dictate",
               ],
            },
         };
      // Template Selection Info
      case 3:
         return {
            title: {
               step: 2,
               mainTitle: "Format your note",
            },
            subTitle: {
               icon: null,
               mainSubtitle: ["Pick a template to determine the structure and layout of your clinical note"],
            },
         };
      // Homescreen_Waiting Info
      case 4:
         return {
            title: {
               step: null,
               mainTitle: "Your first note is almost ready...",
            },
            subTitle: {
               icon: null,
               mainSubtitle: ["Now that you've made a demo note, next time try a secure encounter with a patient"],
            },
         };
      // Note Detail Info
      case 5:
         return {
            title: {
               step: 3,
               mainTitle: "Customize with note tools",
            },
            subTitle: {
               icon: null,
               mainSubtitle: ["Review your AI-powered note and customize it with our suite of note tools"],
            },
         };
      case 6:
         return {
            title: {
               step: null,
               mainTitle: "Get 3 hours back each day",
            },
            subTitle: {
               icon: null,
               mainSubtitle: ["Be home for dinner tonight, and every night, with Playback Pro’s AI Scribe"],
            },
         };
      default:
         return {};
   }
};
